<template>
	<core-layout-content full>
		<!-- Headline -->
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("insurance_type") }}</template>
			<template slot="actions">
				<j-button
					:to="`/${this.$store.state.tenantId}/setup/insurance-types/create`"
					>{{ $t("create_insurance_type") }}</j-button
				>
			</template>
		</core-layout-headline-and-actions>

		<!-- Data Table -->
		<j-card class="bg5">
			<j-data-table :header="header" :list="computedList" :sortable="false">
				<template slot="list" slot-scope="{ item }">
					<td v-for="(column, i) in header" :key="i">
						<template>
							<!-- Name-->
							<template
								v-if="column.field === 'name' && item.tenantId !== 'default'"
							>
								<router-link
									:to="
										`/${$store.state.tenantId}/setup/insurance-types/update/${
											item.typeId
										}`
									"
									>{{ item.name }}</router-link
								>
							</template>

							<!-- Others -->
							<template v-else>{{ item[column.field] }}</template>

							<!-- Actions Field -->
							<!-- Disallow deletion of default insurance types -->
							<template
								v-if="column.field === 'actions' && item.tenantId !== 'default'"
							>
								<div class="action">
									<!-- Delete -->
									<crm-icon
										name="delete"
										size="normal"
										color="cError"
										@click.native="showModal(item.typeId)"
										v-can="'writeProductTypes'"
									/>
								</div>
							</template>
						</template>
					</td>
				</template>
			</j-data-table>
		</j-card>

		<!-- Delete confirmation modal -->
		<j-dialog
			:height="200"
			:width="600"
			:title="$t('delete')"
			type="delete"
			@confirm="onRemove(selectedItemId)"
			>{{
				$t("errors.are_you_sure_you_want_to_delete_insurance_type")
			}}</j-dialog
		>
	</core-layout-content>
</template>

<script>
import JDataTable from "@/components/JDataTable/"
import JCard from "@/components/JCard/"
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JDialog from "@/components/JDialog/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import api from "../api/"

export default {
	components: {
		JDataTable,
		JCard,
		CrmIcon,
		JButton,
		JDialog,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions
	},
	data() {
		return {
			header: [
				{
					field: "name",
					text: this.$t("name")
				},
				{
					field: "typeId",
					text: this.$t("type_id")
				},
				{
					field: "description",
					text: this.$t("description")
				},
				{
					text: this.$t("actions"),
					field: "actions"
				}
			],
			listing: {
				list: []
			},
			selectedItemId: "",
			isLoading: false
		}
	},
	methods: {
		async readAllInsuranceTypes() {
			const res = await api.readAllInsuranceTypes()
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}
			this.listing.list = res.data.productTypes
		},

		showModal(id) {
			this.selectedItemId = id
			this.$modal.show("j-dialog")
		},

		hideModal() {
			this.selectedItemId = null
			this.$modal.hide("j-dialog")
		},

		//TODO: Only delete when no product/policy attached to productType
		async onRemove(id) {
			await api.deleteInsuranceType({ typeId: id })
			this.hideModal()
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("insurance_type_deleted")
				}
			})
			this.readAllInsuranceTypes()
		}
	},
	computed: {
		computedList() {
			return this.listing.list.map(item => ({
				name: item.name,
				typeId: item.typeId,
				tenantId: item.tenantId,
				description: item.description
			}))
		}
	},
	mounted() {
		this.readAllInsuranceTypes()
	}
}
</script>
